<template>

    <div class="col-xs-12 col-md-6 m-auto" style="margin-top: 124px !important;">
        <div class="box box-success">
            <div class="box-header">
                <h3 class="text-center">
                    Welcome {{ApplicantData.FirstNameEN}} {{ApplicantData.LastNameEN}}


                </h3>
                <h4 class="text-center"> Your account was created successfully ,</h4>
            </div>
             <div class="box-body">
                <div class="text-dark m-3">
                  Please check the email <label class="text-danger"> {{ApplicantData.UserEmail}}</label> for the details of the login credentials including The username and password. Once you have received the email,
                   please use the provided information to log back into the account. Thank you.<br/>
                 <div class="text-center"> 

                  <div class="form-inline col-xs-12">
                        <label> Username &nbsp;&nbsp; : </label>
                        <label class="pl-1"> {{ApplicantData.Username}}</label>

                    </div> 
                    <div class="form-inline col-xs-12">
                        <br />
                        <label>Password &nbsp;&nbsp;&nbsp; : </label>
                        <label class="pl-1"> {{ApplicantData.Password}}</label>
                    </div> 
                  <button @click="$router.push('/Login')"  class="btn btn-success mt-3" >Back To Login</button> 
                </div> 
                    <!-- A copy of your credentials were sent to this E-mail
                    <label class="text-danger"> {{ApplicantData.UserEmail}}</label> -->

                    <!-- Please use the following credentials to login to your account , keep them safe and secure <br /> -->


                    </div>
                <!-- <span id="dots">...</span> -->
                <div id="more" v-if="isshown">

                </div> 
                  
               
                <!-- <button @click="show()" id="myBtn" class="btn-xs btn">Read more</button> -->

             </div>
            <div class="box-footer">
                <!-- <div class="col-xs-12">
                    <br />
                    <label>
                        To continue with creating your Application click on <a href="#" class="btn btn-sm btn-success"
                         @click="LoginApplicant()"   >Create Application&nbsp;<i class="fa fa-external-link-square"
                                aria-hidden="true"></i></a>

                    </label>
                </div> -->
                <!-- <div class="col-xs-12 m-3">
                  Please check your email for the details of your login credentials including your username and password. Once you have received the email,
                   please use the provided information to log back into your account. Thank you.
                </div> -->

            </div>
        </div>
    </div>

</template>

<script>
    import {
        ApplicantData
    } from '../../models/Applicant';
    import ApplicantService  from'../../services/Applicant/Applicant.service'
    export default {

        name: 'welcome',
        data() {
            return {
                ApplicantData: new ApplicantData('', '', '', '', '', '', '', '',
                 '', '', '', '', '', '', '', '', '', '','', '', '', '', '', '',''),
                isshown: false,
                ApplicantID : this.$store.state.ApplicantID  ,
                message : ''
            }


        },
        mounted() {
             ApplicantService.GetRegesterdData(this.ApplicantID).then(Response =>{
                this.ApplicantData = Response.data;
                  }, error => {
            
              this.message =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
            }      
            ),
            /*eslint-disable-next-line*/
            console.log(this.$store.state.ApplicantID)
        },
        methods: {
            // loginPage(){
            //   this.$router.push('/login');
            // },
                
           
            // show(){
            //     if(this.isshown){
            //         this.isshown = false
            //     }else  {
            //         this.isshown = true
            //     }
                
            // },
            LoginApplicant(){
                 if (this.ApplicantData.Username && this.ApplicantData.Password) {

            this.$store.dispatch('auth/login', this.ApplicantData).then(
              () => {
                this.$router.push('/dataapp');
              },
              error => {
                //this.loading = false;
                this.message =
                  (error.response && error.response.data) ||
                  error.message ||
                  error.toString();
              }
            );
          }
            }

        }
    }
</script>

<style>
.box {
  position: relative;
  border-radius: 3px;
  background: #ffffff;
  border-top: 3px solid #d2d6de;
  margin-bottom: 20px;
  width: 100%;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.box.box-primary {
  border-top-color: #3c8dbc;
}
.box.box-info {
  border-top-color: #00c0ef;
}
.box.box-danger {
  border-top-color: #dd4b39;
}
.box.box-warning {
  border-top-color: #f39c12;
}
.box.box-success {
  border-top-color: #00a65a;
}
.box.box-default {
  border-top-color: #d2d6de;
}.box-header:before,
.box-body:before,
.box-footer:before,
.box-header:after,
.box-body:after,
.box-footer:after {
  content: " ";
  display: table;
}
.box-header:after,
.box-body:after,
.box-footer:after {
  clear: both;
}
.box-header {
  color: #444;
  display: block;
  padding: 10px;
  position: relative;
}
.box-body {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  padding: 10px;
}
.no-header .box-body {
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}
.box-footer {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
  border-top: 1px solid #f4f4f4;
  padding: 10px;
  background-color: #ffffff;
}
</style>